import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import {
    StyledClose,
    StyledContent,
    StyledOverlay,
    StyledTrigger,
    Form,
    Header,
    SectionBox,
    SendButton,
    SendButtonContainer,
    TitleHeader,
    AiFillCloseCircleIcon,
    IoMdAddCircleOutlineIcon
} from './styles';

import { FormEvent, useState } from 'react';



interface INewFeedProps {
    onFeedCreated: (content: string) => void
}

const NewFeed: React.FC<INewFeedProps> = ({ onFeedCreated }: INewFeedProps) => {

    const [open, setOpen] = useState<boolean>(false);

    const [feedText, setFeedText] = useState("");

    function handleSubmitButton(event: FormEvent) {
        event.preventDefault();

        onFeedCreated(feedText);

        setOpen(false);
    }

    return (
        <Dialog.Root open={open} onOpenChange={setOpen}>
            <StyledTrigger>
                <IoMdAddCircleOutlineIcon /> <h2>Feed</h2>
            </StyledTrigger>

            <Dialog.Portal>
                <StyledOverlay />
                <StyledContent>
                    <StyledClose>
                        <AiFillCloseCircleIcon />
                    </StyledClose>

                    <Header>
                        <TitleHeader>
                            Cadastrar novo Feed
                        </TitleHeader>
                    </Header>
                    <Form
                        onSubmit={handleSubmitButton}
                    >
                        <SectionBox>
                            <label htmlFor="clientName">
                                Feed:
                            </label>
                            <textarea
                                name="clientName"
                                id="clientName"
                                cols={30}
                                rows={10}
                                onChange={(e) => setFeedText(e.target.value)}
                                required
                            />
                        </SectionBox>
                        <SendButtonContainer>
                            <SendButton>
                                Adicionar
                            </SendButton>
                        </SendButtonContainer>
                    </Form>

                </StyledContent>
            </Dialog.Portal>

        </Dialog.Root>
    )

}

export default NewFeed;